import Swal from 'sweetalert2'
global.Swal = Swal